export enum UPLOAD_TYPE {
  BANK_TRANSACTION = 0,
  COMMISSION_UPLOAD = 1,
  PAYPAL_PAYMENTS = 2,
  PAYNAMICS_PAYMENTS = 3,
  IPAY88_PAYMENTS = 4
};
